import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { NavMarker } from 'react-rhumb';
import { ServiceHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/ServiceHubFaqs';
import { ServiceHubProductIcon } from 'pricing-pages-ui-components/productIcon/ServiceHubProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { ServiceHubFeatureTable } from './ServiceHubFeatureTable';
import { ServiceHubMerchCards } from './ServiceHubMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SERVICE_HUB_API_NAMES = ['service-hub-starter', 'service-hub-professional', 'service-hub-enterprise'];
export const ServiceHubPage = () => {
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "SERVICE_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "SERVICE",
      apiNames: SERVICE_HUB_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(ServiceHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.service.pageTitle"
        })]
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.service.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ServiceHubMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "service"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ServiceHubFeatureTable, {})
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "service"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "1400",
      children: /*#__PURE__*/_jsx(ServiceHubFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "service-footer",
      screen: "service",
      apiName: "service-hub-starter"
    })]
  });
};